export default __webpack_public_path__ + "static/media/red-berries.4447760c.png";